const logout = () => {
  let store;
  const localRememberMe = localStorage.getItem("rememberMe");

  if (localRememberMe === "true") {
    store = localStorage;
  } else {
    store = sessionStorage;
  }
  //   if (localRememberMe) {
  //     store.clear();
  //     window.location.reload();
  //   }
  //   return;

  store.clear();
  window.location.reload();
};

export default logout;
